<template>
  <q-timeline
    v-if="hasIdentityRecordsData"
    color="secondary"
    layout="dense"
    side="right"
    class="lead-identity-history-timeline"
  >
    <q-timeline-entry
      v-for="(identityRecord, identityIndex) in sortedIdentityRecordsByDate"
      :key="identityIndex"
    >
      <SdDatetime
        :value="identityRecord.changed_at"
        :timezone="moment.tz.guess()"
        class="q-timeline-subtitle"
      />
      <div class="position-relative">
        <router-link
          v-if="shouldShowInquiryLink(identityRecord)"
          :to="{ name: 'app.inquiries.timeline', params: { id: identityRecord.related_inquiry_id} }"
        >
          <q-chip
            class="inquiry-link round-borders"
            icon="library_books"
            text-color="blue-3"
            dense
          >
            <span class="inquiry-link-id-text">
              Inquiry ID:
              <span class="inquiry-link-text-id">#{{ identityRecord.related_inquiry_id }}</span>
            </span>
          </q-chip>
        </router-link>
        <ul class="lead-identity-history-timeline-list round-borders border-color">
          <li
            v-for="(label, field_name) in identifyHistoryFieldsMapping"
            v-if="identityRecord[field_name]"
            :key="field_name"
            class="lead-identity-history-timeline-list-item border-color"
            v-html="generateIdentityRecordText(identityRecord[field_name], label)"
          />
        </ul>
      </div>
      <div slot="title" />
    </q-timeline-entry>
  </q-timeline>
</template>

<script>
import SdDatetime from '../../plugins/bluejay/components/datetime.vue';

export default {
  name: 'SdLeadIdentityHistoryTimeline',
  components: { SdDatetime },
  props: {
    identityHistory: {
      type: Array,
      default: [],
    },
    displayInquiryLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const identifyHistoryFieldsMapping = {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
    };

    return {
      identifyHistoryFieldsMapping,
    };
  },
  computed: {
    sortedIdentityRecordsByDate() {
      return [...this.identityHistory].sort(
        (a, b) => new Date(b.changed_at) - new Date(a.changed_at),
      );
    },
    hasIdentityRecordsData() {
      return Array.isArray(this.identityHistory) && this.identityHistory.length;
    },
  },
  methods: {
    shouldShowInquiryLink({ related_inquiry_id }) {
      return this.displayInquiryLink && related_inquiry_id;
    },
    generateIdentityRecordText(field, label) {
      if (field.previous_value) {
        return (
          `<strong>${label}</strong> changed from
            <strong>${field.previous_value}</strong>
            to
          <strong>${field.new_value}</strong>`
        );
      }
      return (
        `<strong>${label}</strong> was added:
          <strong>${field.new_value}</strong>`
      );
    },
  },
};
</script>

<style lang="scss">
@import '../../css/common';

  .lead-identity-history-timeline {

    .inquiry-link {
      position: relative;
      margin-bottom: 10px;
      padding: 5px 10px;
      background: none;

      @media (min-width: $size-xl) {
        position: absolute;
        content: "";
        top: -33px;
        right: 0;
        margin-bottom: 0;
      }

      .inquiry-link-id-text {
        color: darken(#e0e0e0, 30%);
      }

      .inquiry-link-text-id {
        text-decoration: underline;
      }
    }

    .lead-identity-history-timeline-list {
      list-style: none;
      padding: 5px 0px 5px 0px;
      border-width: 1px;
      border-style: solid;

      strong {
        font-size: 14px;
      }

      .lead-identity-history-timeline-list-item {
        padding-left: 10px;
        padding-bottom: 2px;
      }

      .lead-identity-history-timeline-list-item + .lead-identity-history-timeline-list-item {
        padding-top: 5px;
        margin-top: 5px;
        border-top-width: 1px;
        border-top-style: solid;
      }

    }
  }
</style>
